/* eslint-disable */
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';

export default class SimilarTour extends Backbone.Epoxy.View {
    initialize({collectionView}) {
        this.render();
        this.collectionView = collectionView;
    }

    transformModelToRender() {
        const tour = this.model.get('tour');
        const {adults, kids, infants} = tour.get('touristGroup');
        return {
            operatorLogo: tour.get('operator').cover || '',
            operatorName: tour.get('operator').name || '',
            oilTax: tour.get('oilTax') || 0,
            oilTaxIsAbsent: tour.get('oilTaxIsAbsent'),
            priceWithOilTax: tour.get('priceWithOilTax') || 0,
            tour,
            adults,
            kids,
            infants,
        };
    }

    render() {
        this.$el.html(this.template(this.transformModelToRender()));
    }

    goToTour(e) {
        e.preventDefault();
        e.stopPropagation();
        this.collectionView.gotoTourPage.bind(this);
        window.open(this.generateUrl());
    }

    generateUrl() {
        const paramsForRouter = {
            sid: searchSessionService.getSearchId(),
            hsid: searchSessionService.getHotelSearchId(),
        };
        return (`/hotel/${window.appConfig.hotelInfo.id}/tourPage?${$.param({identity: this.model.get('id')})}#?${$.param(paramsForRouter)}`);
    }
}